import { Building2 } from "lucide-react";
import { FormattedMessage } from "react-intl";
import { SidebarProvider, SidebarTrigger } from "@/components/molecules/sidebar";
import { AppSidebar } from "@/components/organisms/AppSidebar";
import { LanguageSwitcher } from "@/components/molecules/language-switcher";
import { Logo } from "@/components/atoms/Logo";
import { Outlet } from "react-router-dom";
import { useLanguage } from "@/context/LanguageProvider";
import { useTenant } from "@/context/TenantContext";

export function DashboardLayout() {
  const { isRTL } = useLanguage();
  const { tenants, activeTenantId } = useTenant();
  const noTenant = tenants.length === 0 || activeTenantId === null;

  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full">
        <AppSidebar />
        <div className="flex-1 flex flex-col">
          <header className="h-16 border-b border-border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 sticky top-0 z-50">
            <div
              className={`flex items-center h-full px-3 sm:px-4 md:px-6 gap-2 ${isRTL ? "flex-row-reverse" : ""}`}
            >
              {isRTL ? (
                <>
                  <LanguageSwitcher />
                  <div className="flex-1" />
                  <Logo size="md" showText={true} />
                  <SidebarTrigger className={isRTL ? "ml-4" : "mr-4"} />
                </>
              ) : (
                <>
                  <SidebarTrigger className="mr-4" />
                  <Logo size="md" showText={true} />
                  <div className="flex-1" />
                  <LanguageSwitcher />
                </>
              )}
            </div>
          </header>
          <main className="flex-1 flex flex-col min-h-0 p-3 sm:p-4 md:p-6 bg-background overflow-x-hidden">
            {noTenant ? <NoHospitalEmptyState /> : <Outlet />}
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
}

function NoHospitalEmptyState() {
  return (
    <div className="flex-1 flex items-center justify-center">
      <div className="max-w-md text-center space-y-3">
        <div className="mx-auto h-12 w-12 rounded-full bg-muted flex items-center justify-center">
          <Building2 className="h-6 w-6 text-muted-foreground" />
        </div>
        <h2 className="text-lg font-semibold">
          <FormattedMessage
            id="XYKQTU"
            defaultMessage="No hospital assigned"
            description="Title for the no-tenant empty state"
          />
        </h2>
        <p className="text-sm text-muted-foreground">
          <FormattedMessage
            id="qS6x86"
            defaultMessage="Your account isn't a member of any hospital yet. Please ask your administrator to assign you to one."
            description="Body copy for the no-tenant empty state"
          />
        </p>
      </div>
    </div>
  );
}
